import { render, staticRenderFns } from "./ModifyInfo.vue?vue&type=template&id=549507e2&scoped=true&"
import script from "./ModifyInfo.vue?vue&type=script&lang=js&"
export * from "./ModifyInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModifyInfo.vue?vue&type=style&index=0&id=549507e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549507e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
